<template>
    <iframe src="https://forms.clickup.com/f/26qwm-4760/YAR6WII3QG05P9NFVB" width="100%" class="container-height" style="border: 0;padding: 0;margin: 0">
    </iframe>
</template>

<script>
  export default {
    name: 'Refer',
    metaInfo: {
      title: 'Refer a Nonprofit',
    },
  };
</script>

